import React from "react";
import OptionsRadioButtons from "./OptionsRadioButtons";
import OptionsCards from "./OptionsCards";


const SkuPicker = ({ step }) => {

    switch(step.type){
        case 6: 
            return <OptionsRadioButtons step={step}/>
        default: 
            return <OptionsCards step={step} />
    }
};

export default SkuPicker;
